/**
 * @module selectors/xpath
 */

/**
 * @typedef {module:utils/array~Array} Array
 */

import defaults from './defaults.js'
import array from '../utils/array.js'

/**
 * Returns a frozen array of elements matching the provided XPath selector
 * and optionally a provided target (recommended)
 * @param {string} selector
 * @param {?Node} target
 * @return {Array|Node[]}
 */
export default (selector, target = defaults.document) => {
  const document = target.ownerDocument || target
  const { defaultView } = document
  const { XPathResult } = defaultView
  const { ORDERED_NODE_ITERATOR_TYPE: type } = XPathResult
  const nodes = []
  const result = document.evaluate(selector, target, null, type, null)
  let node = result.iterateNext()
  
  while (node) {
    nodes.push(node)
    node = result.iterateNext()
  }
  
  return array(nodes)
}
